import { Box, Link } from '@mui/material';
import { ArrowUpRightIcon } from 'lucide-react';
import type { IBiomaterial } from '@zero-dash/types';
import type { JSX } from 'react';
import { Highlight } from '@mantine/core';
import CustomTypography from '@/components/Common/Typography';
import { corePalette } from '@/themes/colours';

interface IProps {
  row: Pick<IBiomaterial, 'id'>;
  search?: string | string[];
}

export function BiomaterialIdCell({
  row,
  search,
}: IProps): JSX.Element {
  const labmatrixBaseUrl = import.meta.env.VITE_LABMATRIX_URL_BASE;
  return (
    <Link
      underline="none"
      href={`${labmatrixBaseUrl}/#/biomaterials/${row.id}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Box
        display="flex"
        alignItems="center"
        gap="8px"
      >
        <CustomTypography
          fontWeight="bold"
          color={corePalette.green150}
        >
          <Highlight
            highlightStyles={{ backgroundColor: corePalette.green30 }}
            highlight={search ?? []}
            component="span"
          >
            {String(row.id)}
          </Highlight>
        </CustomTypography>
        <ArrowUpRightIcon />
      </Box>
    </Link>
  );
}
